/* @flow */

import * as React from 'react';
import range from 'lodash/range';
import t from 'app/utils/translate';
import SelectField from './SelectField';

type Props = {
  disabled?: boolean,
  defaultText?: string,
  lightContent?: boolean,
  onChange: string => void,
  options?: Array<*>,
  required?: boolean,
  value?: string,
};

const defaultProps = {
  disabled: false,
  defaultText: t('Day'),
  lightContent: false,
  options: range(1, 32).map(d => ({
    label: d,
    value: d < 10 ? `0${d}` : d,
  })),
  required: false,
  value: undefined,
};

function DaySelectField({
  disabled,
  defaultText,
  lightContent,
  onChange,
  options,
  required,
  value,
}: Props) {
  return (
    <SelectField
      disabled={disabled}
      defaultText={defaultText}
      name="birth_date"
      options={options}
      onChange={onChange}
      required={required}
      value={value}
      lightContent={lightContent}
    />
  );
}

DaySelectField.defaultProps = defaultProps;

export default DaySelectField;
